import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "@/firebase";

async function createNotificationRequest(companyId, notification, targetUid = null) {
  if (!companyId) return null;

  const data = {
    ...(notification.data || {}),
    ...(notification.notificationType
      ? { notificationType: notification.notificationType }
      : {}),
  };

  return addDoc(collection(db, "notificationRequests"), {
    companyId,
    targetUid: targetUid || null,
    notificationType: notification.notificationType || null,
    title: notification.title,
    body: notification.body,
    data,
    status: "pending",
    createdAt: serverTimestamp(),
  });
}

export async function sendCompanyPushNotification(companyId, notification) {
  return createNotificationRequest(companyId, notification);
}

export async function sendWorkerPushNotification(companyId, uid, notification) {
  return createNotificationRequest(companyId, notification, uid);
}
